import { render, staticRenderFns } from "./aiPage.vue?vue&type=template&id=1f9864bc&"
import script from "./aiPage.vue?vue&type=script&lang=js&"
export * from "./aiPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports